'use client';

import { recordWebVisitorV1Api } from '@repo/sdk';
import { useEffect } from 'react';
import { isBotUserAgent } from '../../i18n/is-bot-user-agent';
import { readAttributionFromCookie } from '../attribution/read-attribution-from-cookie';
import { buildWebFingerprint } from '../build-web-fingerprint';
import { getOrCreateVisitorId } from '../get-or-create-visitor-id';
import { markVisitorRecorded } from '../mark-visitor-recorded';
import { wasVisitorRecordedRecently } from '../was-visitor-recorded-recently';

export function useWebVisitorId(): void {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    if (isBotUserAgent(navigator.userAgent)) {
      return;
    }
    const attribution = readAttributionFromCookie();
    const payload = attribution ? JSON.stringify(attribution) : null;
    if (!payload) {
      return;
    }
    const visitorId = getOrCreateVisitorId();
    const key = `${visitorId}|${payload}`;
    if (wasVisitorRecordedRecently(key)) {
      return;
    }
    const fingerprint = buildWebFingerprint();
    recordWebVisitorV1Api({ visitorId, fingerprint, attributionPayload: payload })
      .then(() => markVisitorRecorded(key))
      .catch(() => {});
  }, []);
}
